tippy('[data-tippy-content]', {
  allowHTML: true,
});

// Re-initialize tippy after HTMX swaps in new content
document.body.addEventListener('htmx:afterSwap', function(evt) {
  tippy('[data-tippy-content]', {
    allowHTML: true,
  });
});